import { Text } from '@react-pdf/renderer';

const arabicLetterRegex = (ch) =>
	/[\u0621-\u064A\u066E-\u066F\u0671-\u06D3\u06D5\u06EE-\u06EF\u06FA-\u06FC\u06FF]/.test(ch);

const arabicNumberRegex = (ch) => /[\u0660-\u0669\u06F0-\u06F9]/.test(ch);

const isLatinChar = (ch) => /[A-Za-z]/.test(ch);

const splitTextIntoLanguageParts = (text) => {
	const parts = [];

	let currentPart = '';
	let currentIsArabic = null;

	for (let i = 0; i < text.length; i += 1) {
		const ch = text[i];

		if (arabicLetterRegex(ch)) {
			if (currentIsArabic === false) {
				parts.push({ text: currentPart, isArabic: false });
				currentPart = ch;
				currentIsArabic = true;
			} else {
				currentPart += ch;
				currentIsArabic = true;
			}
		} else if (isLatinChar(ch)) {
			if (currentIsArabic === true) {
				parts.push({ text: currentPart, isArabic: true });
				currentPart = ch;
				currentIsArabic = false;
			} else {
				currentPart += ch;
				currentIsArabic = false;
			}
		} else {
			currentPart += ch;
		}
	}

	if (currentPart) {
		parts.push({ text: currentPart, isArabic: currentIsArabic });
	}

	return parts;
};

const splitTextIntoChunks = (text) => {
	const regex = /(\p{L}+|[\p{N}\u0660-\u0669\u06F0-\u06F9]+|\s+|[^\p{L}\p{N}\s]+)/gu;
	return text.match(regex);
};

const processTextForRendering = (text) => {
	const languageParts = splitTextIntoLanguageParts(text);
	const processedChunks = [];

	languageParts.forEach((part) => {
		const chunks = splitTextIntoChunks(part.text);

		if (part.isArabic) {
			// Reverse the chunks for Arabic text
			const firstWordIndex = chunks.findIndex((chunk) => arabicLetterRegex(chunk));
			if (firstWordIndex > 0) {
				const numbersAndSymbols = chunks.slice(0, firstWordIndex);
				const wordsAndRest = chunks.slice(firstWordIndex).reverse();
				chunks.splice(0, chunks.length, ...numbersAndSymbols, ...wordsAndRest);
			} else {
				chunks.reverse();
			}
		}

		const withArabicNumbersInCorrectOrder = chunks.map((chunk) => {
			if (arabicNumberRegex(chunk)) {
				return chunk.split('').reverse().join('');
			}
			return chunk;
		});

		processedChunks.push(...withArabicNumbersInCorrectOrder);
	});

	return processedChunks;
};

const RTLTextForPDF = ({ text }) => {
	const processedChunks = processTextForRendering(text);

	return (
		<Text>
			{processedChunks.map((chunk, index) => (
				<Text key={index}>{chunk}</Text>
			))}
		</Text>
	);
};

export default RTLTextForPDF;
